import type { ComponentProps } from 'react'
import { useIntl } from 'react-intl'
import FooterList from './FooterList'
import FooterListItem from './FooterListItem'

type InheritedFooterListProps = Pick<ComponentProps<typeof FooterList>, 'title'>

interface Props extends InheritedFooterListProps {
  title: string
  items: Array<App.PageConfig>
}

function FooterItemList({ title, items }: Props) {
  const intl = useIntl()
  return <FooterList title={title}>
    {items.map((item) => {
      const text = typeof item.text === 'string' ? item.text : intl.formatMessage(item.text)
      return <FooterListItem
        key={item.type}
        title={text}
        to={item.url?.to}
        href={item.url?.href}
        target={item.url?.target}
      />
    })}
  </FooterList>
}

export default FooterItemList
